var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgFooter2Logo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 849,
    height: 1273,
    viewBox: "0 0 849 1273",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_154_5625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M773.721 1323.03C713.425 1242.47 675.382 1145.64 664.168 1044.16C660.661 1013.61 659.557 982.882 660.867 952.31L658.802 950.355C603.589 901.869 536.007 873.282 466.025 868.807C396.042 864.333 327.362 884.209 270.112 925.504C212.863 966.799 170.074 1027.33 148.055 1098.16C126.037 1169 125.954 1246.4 147.82 1318.94L147.88 1319.47C213.101 1535.2 335.563 1727.41 499.749 1871.73L849.048 1404.69C821.449 1380.29 796.202 1352.93 773.721 1323.03Z",
    fill: "url(#paint0_linear_154_5625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M979.33 1231.86L1601.3 1777.85C1629.37 1802.48 1661.47 1821.07 1695.76 1832.56C1730.06 1844.04 1765.89 1848.2 1801.19 1844.79C1836.5 1841.38 1870.59 1830.47 1901.52 1812.69C1932.46 1794.9 1959.63 1770.59 1981.49 1741.13C2157.16 1504.48 2240.19 1199.11 2203.8 891.886C2195.19 819.05 2180.2 747.021 2159.04 676.774C2180.88 749.31 2180.78 826.693 2158.76 897.515C2136.73 968.337 2093.94 1028.85 2036.69 1070.13C1979.44 1111.42 1910.77 1131.28 1840.8 1126.81C1770.83 1122.34 1703.26 1093.75 1648.05 1045.28L1645.98 1043.32L1327.65 764.302L705.687 218.386C649.004 168.647 577.108 144.565 505.811 151.437C434.513 158.308 369.653 195.571 325.494 255.029C149.745 491.683 66.7941 797.055 103.113 1104.28C111.731 1177.14 126.721 1249.19 147.881 1319.47C126.015 1246.93 126.097 1169.53 148.116 1098.7C170.134 1027.86 212.923 967.331 270.173 926.036C327.423 884.741 396.103 864.865 466.085 869.339C536.068 873.814 603.649 902.402 658.863 950.888L660.928 952.843L979.33 1231.86Z",
    fill: "#2563EB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_154_5625",
    x1: 385.748,
    y1: 893.538,
    x2: 604.216,
    y2: 1789.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0C77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2563EB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_154_5625"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2111.81,
    height: 1808.51,
    fill: "white",
    transform: "matrix(0.995559 -0.0941434 0.112419 0.993661 0.600098 198.813)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgFooter2Logo);
export default __webpack_public_path__ + "static/media/bg-footer-2-logo.b78c8561cd6d74a98e1bd902060fda97.svg";
export { ForwardRef as ReactComponent };